// Funciones de inspecciones y sus formatos.
// index.js las pone en el state: se usan como this.$store.state.<función>(...). Son métodos, así que `this` es el state.
import { db, auth } from "@/firebase";
import { query, collection, where, getDocs, limit, orderBy, doc, getDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import localforage from "localforage";
import moment from "moment";
import _ from "lodash";
import { colecciones } from "../constantes";

export const funcionesInspecciones = {
  // OBTENER FORMATOS
  async obtenerFormatos(idEmpresaSeleccionada) {
    const q = query(
      collection(db, colecciones.firebase.seguridadVial.formatos.registros),
      where("idEmpresa", "==", idEmpresaSeleccionada),
      where("registro.estado", "in", ["Creado", "Editado"]),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs.map((doc) => doc.data())
      : [];
  },
  // OBTENER INSPECCION
  async obtenerInspeccion(id, modoSinConexion) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.inspecciones.registros,
      );
      return registros ? registros.find((item) => item.id === id) : null;
    } else {
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.inspecciones.registros,
        ),
        where("id", "==", id),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    }
  },
  // OBTENER FORMATO
  async obtenerFormatoInspeccion(id, modoSinConexion) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.formatos.registros,
      );
      const formatos = registros
        ? registros.filter((item) => item.id === id)
        : [];
      return formatos ? formatos : null;
    } else {
      const q = query(
        collection(db, colecciones.firebase.seguridadVial.formatos.registros),
        where("id", "==", id),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    }
  },
  // OBTENER FORMATOS DE SEGUN CATEGORIA
  async obtenerFormatosCategoria(idEmpresa, categoria, modoSinConexion) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.formatos.registros,
      );
      const formatos = registros
        ? registros.filter((item) => item.categoria === categoria)
        : [];
      return formatos ? formatos : null;
    } else {
      const q = query(
        collection(db, "riskmann_seguridadvial_formatos"),
        where("idEmpresa", "==", idEmpresa),
        where("categoria", "==", categoria),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs.map((doc) => doc.data())
        : null;
    }
  },
  // OBTENER ULTIMA INSPECCIÓN DEL USUARIO
  async obtenerUltimaInspeccionUsuario(
    idUsuario,
    idEmpresa,
    fecha,
    modoSinConexion,
  ) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.inspecciones.registros,
      );
      const inspecciones = registros
        ? registros
          .filter(
            (item) =>
              item.idEmpresa === idEmpresa &&
              item.idUsuario === idUsuario &&
              item.registro.filtro === fecha,
          )
          .map((item) => {
            const nuevoItem = { ...item };
            nuevoItem.registro.creacion = moment(
              new Date(
                `${item.registro.realizacion.fecha} ${item.registro.realizacion.hora}`,
              ),
            ).format("YYYY-MM-DD HH:mm:ss");
            return {
              ...nuevoItem,
            };
          })
        : [];
      const filtro = _.orderBy(inspecciones, ["registro.creacion"], ["desc"]);
      return filtro.length > 0 ? filtro[0] : null;
    } else {
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.inspecciones.registros,
        ),
        where("registro.filtro", "==", fecha),
        where("idEmpresa", "==", idEmpresa),
        where("idUsuario", "==", idUsuario),
        where("registro.estado", "in", ["Creado", "Editado"]),
        orderBy("registro.creacion", "desc"),
        limit(1),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    }
  },
  // OBTENER ULTIMA INSPECCIÓN DEL VEHÍCULO
  async obtenerUltimaInspeccionVehiculo(
    idVehiculo,
    tipo,
    fecha,
    modoSinConexion,
  ) {
    if (modoSinConexion) {
      const registros = await localforage.getItem(
        colecciones.localforage.seguridadVial.inspecciones.registros,
      );
      const inspecciones = registros
        ? registros
          .filter(
            (item) =>
              item.tipo === tipo &&
              item.vehiculo.id === idVehiculo &&
              item.registro.filtro === fecha,
          )
          .map((item) => {
            const nuevoItem = { ...item };
            nuevoItem.registro.creacion = moment(
              new Date(
                `${item.registro.realizacion.fecha} ${item.registro.realizacion.hora}`,
              ),
            ).format("YYYY-MM-DD HH:mm:ss");
            return {
              ...nuevoItem,
            };
          })
        : [];
      const filtro = _.orderBy(inspecciones, ["registro.creacion"], ["desc"]);
      return filtro.length > 0 ? filtro[0] : null;
    } else {
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.inspecciones.registros,
        ),
        where("tipo", "==", tipo),
        where("registro.filtro", "==", fecha),
        where("vehiculo.id", "==", idVehiculo),
        where("registro.estado", "in", ["Creado", "Editado"]),
        orderBy("registro.creacion", "desc"),
        limit(1),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    }
  },
  // OBTENER INFORMACION PARA GENERAR INFORME
  async obtenerInformacionInspeccion(item) {
    const obtenerUsuario = await this.obtenerUsuario(auth.currentUser.uid);
    const usuario = {
      correo: obtenerUsuario ? obtenerUsuario.correo : "",
      nombre: obtenerUsuario
        ? `${obtenerUsuario.nombre.toUpperCase()} ${obtenerUsuario.apellido.toUpperCase()}`
        : "",
    };
    // OBTENER DOCUMENTOS DEL VEHICULO
    const obtenerSOAT = item?.vehiculo?.documentos?.idSoat
      ? await this.obtenerDocumentoVehiculo(item.vehiculo.documentos.idSoat)
      : null;
    const obtenerTecno = item?.vehiculo?.documentos?.idTecnicoMecanica
      ? await this.obtenerDocumentoVehiculo(
        item.vehiculo.documentos.idTecnicoMecanica,
      )
      : null;
    const obtenerCartaPropiedad =
      item.tipo === "Trimestral" &&
        item?.vehiculo?.documentos?.idCartaPropiedad
        ? await this.obtenerDocumentoVehiculo(
          item.vehiculo.documentos.idCartaPropiedad,
        )
        : null;
    const obtenerRevisionVehiculo =
      item.esRodamiento && item?.vehiculo?.documentos?.idRevision
        ? await this.obtenerRevisionVehiculo(
          item.vehiculo.documentos.idRevision,
        )
        : null;
    const obtenerComparendosVehiculo = obtenerRevisionVehiculo
      ? obtenerRevisionVehiculo.comparendos.filter(
        (item) => item.estado === "Por Pagar",
      )
      : [];

    // CONVERTIR DOCUMENTOS DEL VEHICULO A FORMATO PARA INFORME
    const soat = obtenerSOAT
      ? {
        id: obtenerSOAT.id,
        entidad: obtenerSOAT.entidad,
        vencimiento: moment(obtenerSOAT.vencimiento).format("DD/MM/YYYY"),
        estado: obtenerSOAT.estado.toUpperCase(),
      }
      : {
        id: "-",
        entidad: "-",
        vencimiento: "-",
        estado: "-",
      };
    const tecno = obtenerTecno
      ? {
        id: obtenerTecno.id,
        entidad: obtenerTecno.entidad,
        vencimiento: moment(obtenerTecno.vencimiento).format("DD/MM/YYYY"),
        estado: obtenerTecno.estado.toUpperCase(),
      }
      : {
        id: "-",
        entidad: "-",
        vencimiento: "-",
        estado: "-",
      };
    const cartaPropiedad = obtenerCartaPropiedad
      ? {
        id: obtenerCartaPropiedad.id,
        entidad: obtenerCartaPropiedad.entidad,
        numero: obtenerCartaPropiedad.numero.toString(),
        expedicion: moment(obtenerCartaPropiedad.expedicion).format(
          "DD/MM/YYYY",
        ),
      }
      : {
        id: "-",
        entidad: "-",
        numero: "-",
        expedicion: "-",
      };
    const comparendosVehiculo =
      obtenerComparendosVehiculo.length > 0
        ? obtenerComparendosVehiculo.map((item) => {
          return {
            fechaImposicion: moment(item.fechaImposicion).format(
              "DD/MM/YYYY",
            ),
            ciudad: item.ciudad,
            causal: item.causal,
            detalle: item.detalle,
            estado: item.estado,
          };
        })
        : [];

    // OBTENER DOCUMENTOS DEL CONDUCTOR
    const obtenerLicencia = item?.conductor?.documentos?.idLicencia
      ? await this.obtenerLicenciaConductor(
        item.conductor.documentos.idLicencia,
      )
      : null;
    const obtenerExamen =
      item?.esRodamiento && item?.conductor?.documentos?.idExamen
        ? await this.obtenerExamenConductor(
          item.conductor.documentos.idExamen,
        )
        : null;
    const obtenerCapacitacion = item?.conductor?.documentos?.idCapacitacion
      ? await this.obtenerCapacitacionConductor(
        item.conductor.documentos.idCapacitacion,
      )
      : null;
    const obtenerRevisionConductor =
      item?.esRodamiento && item?.conductor?.documentos?.idRevision
        ? await this.obtenerRevisionConductor(
          item.conductor.documentos.idRevision,
        )
        : null;
    const obtenerComparendosConductor =
      obtenerRevisionConductor &&
        Array.isArray(obtenerRevisionConductor.comparendos)
        ? obtenerRevisionConductor.comparendos.filter(
          (item) => item.estado === "Por Pagar",
        )
        : [];

    // CONVERTIR DOCUMENTOS DEL CONDUCTOR A FORMATO PARA INFORME
    const licencia = obtenerLicencia
      ? {
        id: obtenerLicencia.id,
        identificacion: obtenerLicencia.numeroIdentificacion,
        expedicion: moment(obtenerLicencia.expedicion).format("DD/MM/YYYY"),
        categorias: Array.isArray(obtenerLicencia.categorias)
          ? obtenerLicencia.categorias
            .map((categoria) => categoria.id)
            .join(", ")
          : "",
      }
      : {
        id: "-",
        identificacion: "-",
        expedicion: "-",
        categorias: [],
      };
    const examen = obtenerExamen
      ? {
        id: obtenerExamen.id,
        ips: obtenerExamen.ips,
        vencimiento: moment(obtenerExamen.vencimiento).format("DD/MM/YYYY"),
        estado: (obtenerExamen.estado || "").toString().toUpperCase(),
      }
      : {
        id: "-",
        ips: "-",
        vencimiento: "-",
        estado: "-",
      };
    const capacitacion = obtenerCapacitacion
      ? {
        id: obtenerCapacitacion.id,
        nombre: obtenerCapacitacion.nombre,
        vencimiento: moment(obtenerCapacitacion.vencimiento).format(
          "DD/MM/YYYY",
        ),
        estado: (obtenerCapacitacion.estado || "").toString().toUpperCase(),
      }
      : {
        id: "-",
        nombre: "-",
        vencimiento: "-",
        estado: "-",
      };
    const comparendosConductor =
      obtenerComparendosConductor.length > 0
        ? obtenerComparendosConductor.map((item) => {
          return {
            fechaImposicion: moment(item.fechaImposicion).format(
              "DD/MM/YYYY",
            ),
            ciudad: item.ciudad,
            causal: item.causal,
            detalle: item.detalle,
            estado: item.estado,
          };
        })
        : [];

    // OBTENER DATOS DEL SUPERVISOR
    const obtenerSupervisor =
      item.idSupervisor && item.idEmpresa
        ? await this.obtenerTrabajador(item.idSupervisor, item.idEmpresa)
        : null;
    const supervisor = obtenerSupervisor
      ? obtenerSupervisor
      : {
        nombre: "-",
        numeroIdentificacion: "-",
        correo: "-",
        foto: "-",
        cargo: "-",
      };

    // OBTENER DATOS DEL ENCARGADO
    const obtenerEncargado =
      item.idUsuario && item.idEmpresa
        ? await this.obtenerTrabajador(item.idUsuario, item.idEmpresa)
        : null;
    let encargado = obtenerEncargado
      ? obtenerEncargado
      : {
        nombre: "-",
        numeroIdentificacion: "-",
        correo: "-",
        foto: "-",
        cargo: "-",
      };

    // OBTENER ITEMS DEL FORMATO
    const items =
      item.formato && Array.isArray(item.formato)
        ? await Promise.all(
          item.formato.map((item) => {
            return {
              nombre: item.nombre,
              campos: item.campos.map((campo) => {
                if (campo.items) {
                  const campoItems = campo.items.filter(
                    (item) => item.observaciones.respuesta,
                  );
                  const observacion = campoItems.map(
                    (item) => item.observaciones.respuesta,
                  );
                  const obtenerCriterios = campo.items.filter(
                    (itemCampo) => itemCampo.nombre === campo.respuesta,
                  );
                  return {
                    nombre: campo.nombre,
                    respuesta: campo.respuesta,
                    criterio:
                      obtenerCriterios.length > 0
                        ? obtenerCriterios[0].criterio
                        : "No Registra",
                    observacion: observacion[0],
                  };
                } else {
                  return {
                    nombre: campo.nombre,
                    respuesta: campo.respuesta,
                    observacion: null,
                  };
                }
              }),
            };
          }),
        )
        : [];

    // CARGADA DESDE PAPEL Y AUDITORÍA SOFU: la fila trae la fecha ya escrita, así que el registro se lee de la inspección
    let cargadaDesdePapel = "";
    let auditoriaSofu = false;
    try {
      const documento = await getDoc(
        doc(db, colecciones.firebase.seguridadVial.inspecciones.registros, item.id),
      );
      const registro = documento.exists() ? documento.data().registro : null;
      cargadaDesdePapel = this.fechaCargaDesdePapel(registro);
      auditoriaSofu = !!(registro && registro.auditoriaSofu);
    } catch (error) {
      cargadaDesdePapel = "";
    }
    // La hizo un auditor SOFU, que no está vinculado al espacio: sale con sus datos y ese cargo
    if (auditoriaSofu) {
      const auditor = await this.obtenerAuditorSofu(item.idUsuario);
      if (auditor) encargado = auditor;
    }

    // ELIMINAR DATOS REDUNDANTES DE LOS OBJETOS DE CONDUCTOR Y VEHICULO
    const copia = JSON.parse(JSON.stringify(item));
    const vehiculo = { ...copia.vehiculo };
    const conductor = { ...copia.conductor };
    delete vehiculo.documentos;
    delete conductor.documentos;

    // RETORNO EL OBJETO CON LA INFORMACION RECOLECTADA
    return {
      inspeccion: {
        id: item.id,
        vehiculo: {
          ...vehiculo,
          documentos: {
            soat,
            tecno,
            cartaPropiedad,
            comparendos: comparendosVehiculo,
          },
        },
        conductor: {
          ...conductor,
          documentos: {
            licencia,
            examen,
            capacitacion,
            comparendos: comparendosConductor,
          },
        },
        supervisor,
        encargado,
        items,
        tipo: item.tipo,
        resultado: item.resultado,
        ubicacion: item.ubicacion,
        registro: item.registro,
        cargadaDesdePapel,
        esRodamiento: item.esRodamiento,
        declaracionVeracidad: item.declaracionVeracidad,
      },
      usuario,
    };
  },
  // FECHA EN QUE SE CARGÓ UNA INSPECCIÓN HECHA EN PAPEL ("DD/MM/YYYY"; vacía si no es de papel)
  // La de su sincronización: registro.creacion lleva la fecha del papel
  fechaCargaDesdePapel(registro) {
    if (!registro || registro.origen !== "Papel") return "";
    const carga = registro.sincronizacion;
    return carga && typeof carga.toDate === "function"
      ? moment(carga.toDate()).format("DD/MM/YYYY")
      : "";
  },
  // QUIEN HIZO UNA INSPECCIÓN DE AUDITORÍA (registro.auditoriaSofu): el auditor SOFU no está vinculado al espacio,
  // así que sale con los datos de su usuario y el cargo «AUDITOR SOFU», con la forma de obtenerTrabajador
  async obtenerAuditorSofu(idUsuario) {
    const usuario = idUsuario ? await this.obtenerUsuario(idUsuario) : null;
    if (!usuario) return null;
    const nombre = usuario.nombre ? usuario.nombre.toUpperCase() : "";
    const apellido = usuario.apellido ? usuario.apellido.toUpperCase() : "";
    const documento = usuario.documento && usuario.documento.numero ? usuario.documento.numero.toString() : "";
    return {
      id: usuario.id,
      idUsuario: usuario.id,
      nombre: `${nombre} ${apellido}`.trim(),
      numeroIdentificacion: this.ocultarCaracteres(documento, 3),
      correo: this.ocultarCorreo(usuario.correo ? usuario.correo.toUpperCase() : ""),
      foto: usuario.foto && usuario.foto.url ? usuario.foto.url : "",
      cargo: "AUDITOR SOFU",
      telefono: usuario.telefono || "",
    };
  },
  //VALIDADOR DE EDICIÓN DE LA INSPECCIÓN
  validadorPermisoEditarInspeccionHoy(fechaFiltro, privilegioEliminar) {
    if (fechaFiltro !== null) {
      let puedoEditar = true;
      const hoy = moment().format("YYYY-MM-DD");
      let fechaValidada = moment(fechaFiltro, "DD/MM/YYYY hh:mm A").format(
        "YYYY-MM-DD",
      );
      if (privilegioEliminar) {
        puedoEditar = true;
      } else {
        fechaValidada !== hoy ? (puedoEditar = false) : (puedoEditar = true);
      }
      if (!puedoEditar) {
        Swal.fire({
          icon: "warning",
          title: "Edición no permitida",
          text: "El tiempo límite de 24 horas para editar ha expirado.",
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn btn-primary btn-md fw-bold",
          },
        });
      }
      return puedoEditar;
    }
  },
  // OBTENER CAMPOS Y TOTALES DE FORMATO
  async obtenerCamposTotalesFormato(secciones) {
    // OBTENER LOS CAMPOS CON SU RESPECTIVO NOMBRE Y VALOR
    const campos = secciones.map((item) => {
      return {
        nombre: item.nombre,
        campos: item.campos.map((campo) => {
          if (campo.items) {
            const campoItems = campo.items.filter(
              (item) => item.observaciones.respuesta,
            );
            const observacion = campoItems.map(
              (item) => item.observaciones.respuesta,
            );
            const obtenerCriterios = campo.items.filter(
              (itemCampo) => itemCampo.nombre === campo.respuesta,
            );
            return {
              nombre: campo.nombre
                ? campo.nombre.toUpperCase()
                : "No Registra",
              valor: campo.respuesta ? campo.respuesta : "No Registra",
              criterio:
                obtenerCriterios.length > 0
                  ? obtenerCriterios[0].criterio
                  : "No Registra",
              observacion: observacion.length > 0 ? observacion[0] : "-",
            };
          } else {
            return {
              nombre: campo.nombre
                ? campo.nombre.toUpperCase()
                : "No Registra",
              valor: campo.respuesta ? campo.respuesta : "No Registra",
              observacion: "-",
            };
          }
        }),
      };
    });

    // MAPEAR LOS CAMPOS OBTENIDOS
    const nuevosCampos = campos.flatMap((item) => item.campos);

    // CALCULAR LOS TOTALES POR CADA VALOR DEL CAMPO
    const totales = {
      totalSi:
        nuevosCampos.length > 0
          ? nuevosCampos.filter((campo) => campo.valor === "Si").length
          : 0,
      totalNo:
        nuevosCampos.length > 0
          ? nuevosCampos.filter((campo) => campo.valor === "No").length
          : 0,
      totalBueno:
        nuevosCampos.length > 0
          ? nuevosCampos.filter((campo) => campo.valor === "Bueno").length
          : 0,
      totalMalo:
        nuevosCampos.length > 0
          ? nuevosCampos.filter((campo) => campo.valor === "Malo").length
          : 0,
      totalRegular:
        nuevosCampos.length > 0
          ? nuevosCampos.filter((campo) => campo.valor === "Regular").length
          : 0,
      totalNA:
        nuevosCampos.length > 0
          ? nuevosCampos.filter((campo) => campo.valor === "N/A").length
          : 0,
      totalNoRegistra:
        nuevosCampos.length > 0
          ? nuevosCampos.filter((campo) => campo.valor === "No Registra")
            .length
          : 0,
    };

    return {
      campos: nuevosCampos,
      totales: totales,
    };
  },
  // VALIDAR CAMPOS DE FORMATOS
  async validarCamposFormato(secciones) {
    const camposSecciones = secciones.flatMap((seccion) => seccion.campos);
    const camposObligatorios = camposSecciones.filter((campo) => {
      if (campo.tipo !== "Personalizado" && campo.items) {
        const itemsConObservaciones = campo.items.filter((item) => {
          return (
            item.observaciones.valor &&
            campo.respuesta === item.nombre &&
            !item.observaciones.respuesta
          );
        });
        return (
          campo.respuesta === null ||
          (Array.isArray(campo.respuesta) && campo.respuesta.length === 0) ||
          itemsConObservaciones.length > 0
        );
      }
    });
    return camposObligatorios.length > 0 ? true : false;
  },
};
